module.exports = __webpack_public_path__ + "img/in-use-ann-taboada@2x.2f4fddd4.jpg";